



























































































































































































































































































/*
  修改信息根据id获取到当前得伤情信息数据遍历
*/
import { Component, Vue, Watch } from "vue-property-decorator";
// import Pagination from "@/components/Pagination/index.vue";

import {
  getinjurylist,
  addinjurylist,
  getinjuryInfo,
  editinfo,
  handleupfile,
} from "@/api/injuryMange";
import { parse } from "path";
// import { ref } from "vue";

@Component({
  name: "equipManage",
  // components: { Pagination },
})
export default class extends Vue {
  [x: string]: /*
    修改信息根据id获取到当前得伤情信息数据遍历
  */
  any;
  mounted() {
    if (this.listQuery.page == 1) {
      this.listQuery.page = 0;
    }
    this.getlist(this.listQuery);
  }
  private total: number = 0;
  private isloading = true;
  private isuse = 1;
  private isusestate: any = "";
  private formObj = {
    search: "",
    dialogVisible: false,
    showMessage: "",
    listLoading: false,
    uploadfile: false,
    fileisloading: false,
    disibleState: false,
  };
  private addParams: any = {
    injurename: "",
    isuse: "",
    injuryclass: [
      { injurytitle: "", injurydescription: "", injurytime: "", sort: "" },
    ],
  };
  private editParams: any = {
    injurename: "",
    isuse: "",
    injuryclass: [
      { injurytitle: "", injurydescription: "", injurytime: "", sort: "" },
    ],
    id: "",
    isdelete: 1,
  };
  private fileSizeIsSatisfy: any = [];
  private tableData: any = [];
  private options = [
    {
      key: "启用",
      value: 1,
    },
    {
      key: "禁用",
      value: 0,
    },
  ];
  private value: boolean = true;
  private dialogTitle: string = "";

  // 调用页面列表是接口参数
  private listQuery: any = {
    isuse: 2,
    name: "",
    page: 1,
    limit: 10,
  };
  private currtentpage = 1;
  private searchData() {
    this.listQuery.page = 1;
    this.listQuery.limit = 10;
    this.getlist(this.listQuery);
  }
  private onCreatItem() {
    this.formObj.dialogVisible = true;
    this.formObj.showMessage = "新增伤情管理";
    this.editParams = {
      injurename: "",
      isuse: "",
      injuryclass: [{ injurytitle: "", injurydescription: "", injurytime: "" }],
      id: "",
      isdelete: "",
    };
  }
  private uploadfile() {
    this.formObj.uploadfile = true;
    this.fileSizeIsSatisfy = [];
  }
  private handleExceed(file: any, fileList: any) {}
  private fileOnChange(file: any) {
    let that: any = this;
    that.fileSizeIsSatisfy.push(file.raw);
  }
  private fileBeforeRemove(file: any, fileList: any) {
    this.fileSizeIsSatisfy = fileList;
  }
  private async savefile() {
    let formdata = new FormData();
    for (var i = 0; i < this.fileSizeIsSatisfy.length; i++) {
      formdata.append("file", this.fileSizeIsSatisfy[i]);
    }
    this.formObj.fileisloading = true;
    await handleupfile(formdata).then((res) => {
      if (res.code === 200) {
        this.formObj.fileisloading = false;
        this.formObj.uploadfile = false;
        this.$message.success("伤情表上传成功");
        this.getlist(this.listQuery);
      }
    });
  }
  private async editItem(params: any) {
    this.editParams.id = params.id;
    this.formObj.dialogVisible = true;
    this.formObj.showMessage = "编辑伤情管理";
    const param = {
      id: params.id,
    };
    await getinjuryInfo(param).then((res) => {
      if (res.code === 200) {
        this.addParams.injurename = res.data.injuryname;
        this.isuse = res.data.isuse;
        if (res.data.injuryclass.length === 0) {
          this.addParams.injuryclass = [
            { injurytitle: "", injurydescription: "", injurytime: "" },
          ];
        } else {
          res.data.injuryclass.forEach((res: any) => {
            res.injurytime = Number(res.injurytime);
          });
          this.addParams.injuryclass = res.data.injuryclass;
        }
      }
    });
  }
  private removeItem(params: any) {
    if (this.isusestate === "") {
      this.listQuery = {
        name: "",
        page: 1,
        limit: 10,
        isuse: 2,
      };
    } else {
      this.listQuery = {
        name: "",
        page: 1,
        limit: 10,
        isuse: this.isusestate,
      };
    }
    this.editParams = params;
    if (params.isuse === false) {
      params.isuse = 0;
    } else {
      params.isuse = 1;
    }
    this.editParams.isdelete = 0;
    this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(async () => {
      await editinfo(this.editParams).then((res: any) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getlist(this.listQuery);
          // this.editParams = {
          //   injurename: "",
          //   isuse: "",
          //   injuryclass: [
          //     { injurytitle: "", injurydescription: "", injurytime: "" },
          //   ],
          //   id: "",
          //   isdelete: "",
          // };
        } else {
          this.$message({
            message: "删除失败",
            type: "warning",
          });
        }
      });
    });
  }

  private handleClose(done: any) {
    const form = this.$refs.ruleForm as any;
    this.formObj.dialogVisible = false;
    form.resetFields();
    this.addParams = {
      injurename: "",
      injuryclass: [
        { injurytitle: "", injurydescription: "", injurytime: "", sort: "" },
      ],
      isuse: "",
    };
  }
  private handleCloseFile() {
    this.formObj.uploadfile = false;
  }
  private clearSearch() {
    this.listQuery.name = "";
    this.isusestate = "";
    this.listQuery.page = 1;
    this.listQuery.limit = 10;
    this.getlist(this.listQuery);
  }
  private async changeSwitch(param: any) {
    if (this.isusestate === "") {
      this.listQuery = {
        name: "",
        page: 1,
        limit: 10,
        isuse: 2,
      };
    } else {
      this.listQuery = {
        name: "",
        page: 1,
        limit: 10,
        isuse: this.isusestate,
      };
    }
    this.editParams = param;
    this.editParams.isdelete = 1;
    if (param.isuse === true) {
      this.editParams.isuse = 1;
    } else {
      this.editParams.isuse = 0;
    }
    await editinfo(this.editParams).then((res: any) => {
      if (res.code === 200) {
        this.$message({
          type: "success",
          message: "伤情状态更改成功",
        });
        this.getlist(this.listQuery);
        this.editParams = {
          injurename: "",
          isuse: "",
          injuryclass: [
            { injurytitle: "", injurydescription: "", injurytime: "" },
          ],
          id: "",
          isdelete: "",
        };
      }
    });
  }

  private async subMitData() {
    const form = this.$refs.ruleForm as any;
    this.addParams.isuse = this.isuse;
    form.validate(async (valid: boolean) => {
      if (valid) {
        /* ajax数据请求 */
        this.listQuery = {
          isuse: 2,
          limit: 10,
          name: "",
          page: 1,
        };
        if (this.editParams.id) {
          if (this.addParams.isuse) {
            this.editParams.isuse = 1;
          } else {
            this.editParams.isuse = 0;
          }
          this.editParams.injurename = this.addParams.injurename;
          this.editParams.injuryclass = this.addParams.injuryclass;
          this.editParams.isdelete = 1;
          this.editParams.injuryclass.forEach((res: any, index: any) => {
            res.sort = index;
          });
          await editinfo(this.editParams).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              // this.addParams = {
              //   injurename: "",
              //   injuryclass: [
              //     { injurytitle: "", injurydescription: "", injurytime: "" },
              //   ],
              //   isuse: "",
              // };
              // this.editParams = {
              //   injurename: "",
              //   isuse: "",
              //   injuryclass: [
              //     { injurytitle: "", injurydes: "", injurytime: "" },
              //   ],
              //   id: "",
              //   isdelete: "",
              // };
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.getlist(this.listQuery);
            }
          });
        } else {
          this.addParams.injuryclass.forEach((res: any, index: any) => {
            res.sort = index;
          });
          await addinjurylist(this.addParams).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.addParams = {
                injurename: "",
                injuryclass: [
                  { injurytitle: "", injurydescription: "", injurytime: "" },
                ],
                isuse: "",
              };
              this.formObj.dialogVisible = false;
              form.resetFields();
              this.getlist(this.listQuery);
            }
          });
        }
      } else {
        return false;
      }
    });
  }

  // 伤情分类新增描述项
  private addTime() {
    this.addParams.injuryclass.push({
      id: "",
      injurytitle: "",
      injurydescription: "",
      injurytime: "",
    });
  }
  //获取列表
  private async getlist(parm: any) {
    await getinjurylist(parm).then((res) => {
      if (res.code === 200) {
        this.isloading = false;
        res.data.items.forEach((item: any) => {
          item.isuse = item.isuse == 1 ? true : false;
        });
        this.tableData = res.data;
        this.total = res.data.total;
      }
    });
  }

  private reduceTime(index: number) {
    if (this.addParams.injuryclass.length === 1) {
      this.$message({
        type: "warning",
        message: "最少需要一条伤情描述",
      });
    } else {
      this.addParams.injuryclass.splice(index, 1);
    }
  }
  private changeIsuse(val: any) {
    if (val === "") {
      this.listQuery.isuse = 2;
    } else {
      this.listQuery.isuse = val;
    }

    this.listQuery.page = 1;
    this.listQuery.limit = 10;
    this.getlist(this.listQuery);
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getlist(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getlist(this.listQuery);
  }
  private textareaKeydown() {
    let e = window.event || arguments[0];
    // console.log(e,e.keyCode)
    if (e.key == "Enter" || e.code == "Enter" || e.keyCode == 13) {
      e.returnValue = false;
      return false;
    }
  }
  // 页面居中
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }

  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
